import { render, staticRenderFns } from "./AssociateUser.vue?vue&type=template&id=627cfc8a"
import script from "./AssociateUser.vue?vue&type=script&lang=ts"
export * from "./AssociateUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports